module.exports = __webpack_public_path__ + "static/emanuel-background-video-0f866036bffee5c0dd234ecf5de5f90a.mp4";